import FinancialEntryHTML from "../FinancialEntry/FinancialEntryHTML";
export default function ExpenseHTML() {
  return <FinancialEntryHTML Type="Expense" />;
}
